import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import SmartEducation from './pages/SmartEducation';
import SmartService from './pages/SmartService';
import SmartOffice from './pages/SmartOffice';
import SmartSupport from './pages/SmartSupport';
import SmartManagement from './pages/SmartManagement';
import SmartAI from './pages/SmartAI';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/smart-education" element={<SmartEducation />} />
        <Route path="/smart-service" element={<SmartService />} />
        <Route path="/smart-office" element={<SmartOffice />} />
        <Route path="/smart-support" element={<SmartSupport />} />
        <Route path="/smart-management" element={<SmartManagement />} />
        <Route path="/smart-ai" element={<SmartAI />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;